import type { FC } from 'react'
import { usePage } from '@dhl-ui/page'
import { LegalLinks } from '@dhl/legal'

export const EndNode: FC = () => {
  const { isExpanded } = usePage()
  return isExpanded ? <LegalLinks /> : null
}
